// extracted by mini-css-extract-plugin
var _1 = "CardSide_active__1921e";
var _2 = "CardSide_back__214e8";
var _3 = "CardSide_book__32979";
var _4 = "CardSide_diagonalFlip__4aeaf";
var _5 = "CardSide_fadeEffect__8e82d";
var _6 = "CardSide_horizontalFlip__c8057";
var _7 = "CardSide_icon__c7818";
var _8 = "CardSide_mask__17ca9";
var _9 = "CardSide_pauseAnimation__60f51";
var _a = "CardSide_pdf__302f2";
var _b = "CardSide_root__7031e";
var _c = "CardSide_textContainer__410d1";
var _d = "CardSide_textInner__fcf2b";
var _e = "CardSide_verticalFlip__ca2d0";
export { _1 as "active", _2 as "back", _3 as "book", _4 as "diagonalFlip", _5 as "fadeEffect", _6 as "horizontalFlip", _7 as "icon", _8 as "mask", _9 as "pauseAnimation", _a as "pdf", _b as "root", _c as "textContainer", _d as "textInner", _e as "verticalFlip" }
